import React, { useEffect, useState } from "react";
import "./message.css";
import { Badge } from "reactstrap";
import { FaMessage } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import createMessageNotifySelector from "store/Message/selector";
import createUserSelector from "store/users/selector";
import axios from "axios";
import { callMessageNotification } from "store/Message/actions";
import RequestFootageModal from "./RequestFootageModal";
import { BiSolidCameraMovie } from "react-icons/bi";

const RequestFootage = () => {
    const dispatch = useDispatch();
    const messageSelector = useSelector(createMessageNotifySelector);
    const { messageNotifications } = messageSelector;
    const userSelector = useSelector(createUserSelector);
    const { loginUser } = userSelector;

    const [filteredNotifications, setFilteredNotifications] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    const handleReadMessage = async (messages) => {
        try {
            const unreadIds = messages
                .filter((m) => !m.isRead)
                .map((m) => m._id);

            if (unreadIds.length === 0) {
                toggleModal();
                return;
            }

            await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/twilio/messages/read-multiple`,
                { messageIds: unreadIds }
            );

            dispatch(callMessageNotification(true));
            toggleModal();
        } catch (error) {
            console.error(
                "Error marking messages as read:",
                error.response?.data || error.message
            );
        }
    };

    useEffect(() => {
        if (messageNotifications) {
            // ✅ ONLY RequestFootage (CameraAlarms filtered out)
            setFilteredNotifications(
                messageNotifications.filter(
                    (notification) =>
                        notification.MessageType === "RequestFootage"
                )
            );
        }
    }, [messageNotifications]);

    const unreadMessagesCount =
        filteredNotifications.filter((msg) => !msg.isRead).length;

    return (
        <div>
            <div
                className="ms-5"
                style={{
                    position: "relative",
                    color: unreadMessagesCount > 0 ? "red" : "#ffffff",
                    cursor: "pointer",
                }}
                onClick={() =>
                    handleReadMessage(filteredNotifications || [])
                }
            >
                <BiSolidCameraMovie size={35} />
                {unreadMessagesCount > 0 && (
                    <Badge
                        color="danger"
                        style={{
                            position: "absolute",
                            top: "-5px",
                            right: "-5px",
                            borderRadius: "50%",
                            padding: "3px",
                            fontSize: "12px",
                            width: "20px",
                            height: "20px",
                        }}
                    >
                        {unreadMessagesCount}
                    </Badge>
                )}
            </div>

            {modalOpen && (
                <RequestFootageModal
                    messageNotifications={filteredNotifications}
                    toggle={toggleModal}
                />
            )}
        </div>
    );
};

export default RequestFootage;
